var path = '/activate/confirmation/confirmation.html';
var html = "<md-card class=has-circle-icon> <md-card-header> <md-card-header-text> <h1 class=\"md-title circle-icon account\">{{::route.title}}</h1> <p class=md-subhead>You’re all set and ready to go!</p> </md-card-header-text> </md-card-header> <md-card-content class=only-buttons> <div layout=row layout-align=center> <md-button class=\"md-primary md-raised\" ng-href={{config.loginRedirectUrl}} flex=100 flex-gt-xs=50> Get Started </md-button> </div> </md-card-content> </md-card> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./activate/confirmation/confirmation.html
// module id = 271
// module chunks = 0